import { Component, OnInit } from '@angular/core';

import { PolicyService } from '../../service/policy.service';
import { PolicyModel } from '../../model/policy.model';
import { ProcessService } from 'src/app/service/process.service';
import { AuthenticationService } from 'src/app/service/auth.service';
import { UserModel } from '../../model/user.model';
import swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { DesignService } from 'src/app/service/design.service';
declare var $: any;

@Component({
  selector: 'app-process',
  templateUrl: './processes.component.html',
  styleUrls: ['./processes.component.scss']
})
export class ProcessesComponent implements OnInit {

  policies: PolicyModel[];
  userName: UserModel = new UserModel;
  validatedPolicyAccess : boolean = false;
  pageHeadTitle: string;
  sourceUrl: string | null;

  constructor(
    private router: Router,
    private policyService: PolicyService,
    private processService: ProcessService,
    private authService: AuthenticationService,
    private spinner: NgxSpinnerService,
    private designService: DesignService,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      let id = `${params.typeId ? params.typeId : params.policyId}`
      let routeUrl = `/processes/${params.typeId ? "type": "policy"}/${id}`
      this.pageHeadTitle = this.designService.getMenuNameFromRoute(routeUrl)
      const menuConfig = this.designService.getCurrentMenuConfig();
      if (menuConfig && menuConfig.attributes) {
        const sourceUrlAttribute = menuConfig.attributes.find(attr => attr.key.toLowerCase() === 'source url');
        this.sourceUrl = sourceUrlAttribute ? sourceUrlAttribute.value : null;
      } else {
        this.sourceUrl = null;
      }
      console.log(params);
    });

    this.processService.resetModel()

    this.policyService.list().subscribe(data => {
      this.loadPolicy(data);
    }, (error)=> this.handleHttpError(error));
  }

  loadPolicy(data) {
    this.policies = data;
    this.userName = this.authService.getUser();
  }

  validateAccessPolicy(policy : PolicyModel): boolean {
    let validated :boolean = false;
    let editar = policy.myStep != undefined ?  policy.myStep.attributes.find(element => element.key == 'Editar') : null;
    if(editar != null){
    let role = editar.attributes.find(element => element.key == 'Role');
    if(role != undefined){
      role.attributes.forEach(policyRoles =>{
        this.userName.roles.forEach(userRoles => {
          if(userRoles == policyRoles.key && policyRoles.value == 'true')
            validated = true;
        });
      });
      }else{
        validated = true;
      }
    }else{
      validated = true;
    }
    return validated;
  }

  selectPolicy(id: string) {
    if (id != null) {
      $('body').removeClass('modal-open');
      $('.modal-backdrop').removeClass('fade');
      $('.modal-backdrop').removeClass('show');
      $('.modal-backdrop').removeClass('modal-backdrop');
      this.processService.newProcess(id);
    }
  }

  getOptionByKey(child: PolicyModel, type: string): string {
    if (!child.options)
      return null;

    let attribute = child.options.find(option => option.key == type);

    if (attribute)
      return attribute.value;
  }

  private handleHttpError(error: any) {
    this.spinner.hide();

    if(error.status == 401) {
      this.authService.logout()
      this.router.navigate(['login']);
    } else if(error.status == 403) {
      swal.fire("Atenção", "Este usuário não tem permissão para acessar este conteúdo.")
        .then(() => this.router.navigate([""]).then(() => swal.close()))
    } else if(error.message) {
      swal.fire("Atenção", error.message, "error").then(() => {
        if(error.goBackToHome) {
          this.router.navigate([""]).then(() => swal.close())
        }
      })
    } else {
      swal.fire("Atenção", "Algo errado aconteceu; Por favor, tente novamente.", "error")
    }
  }
}
